import { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Button } from 'components/buttons/Button/Button';
import { ReactComponent as SVG } from 'images/card-decor.svg';

gsap.registerPlugin(ScrollTrigger);

const ProductCard = ({ index, title, text, img, logo, buttonText, buttonLink }) => {
    const number = String(index + 1).padStart(2, '0');

     useEffect(() => {
         gsap.utils.toArray('.product-card__image-bg').forEach((element) => {
             gsap.to(element, {
                 ease: 'none',
                 scrollTrigger: {
                     trigger: element,
                     start: 'bottom bottom',
                     end: 'top top',
                     scrub: true,
                     onUpdate: self => {
                         const scrollPercentage = self.progress * 16;
                         gsap.to(element, { yPercent: scrollPercentage });
                     },
                 },
             });
         });
     }, []);

    return (
        <div className={`product-card ${index % 2 !== 0 ? 'product-card--reverse' : ''}`}>
            <div className="product-card__image" data-index={'• ' + number}>
                <SVG />
                <img src={img} alt="product-item" className={`product-card__image-bg`} />
                {logo && (
                    <div className="product-card__image-logo">
                        <img src={logo} alt="product-logo" />
                    </div>
                )}
            </div>
            <div className="product-card__content">
                <h3>{title}</h3>
                <p className="body1">{text}</p>
                <Button type="learn-more-arrow" href={buttonLink}>
                    {buttonText}
                </Button>
            </div>
        </div>
    );
};

export default ProductCard;
